import React, { Fragment, useEffect, useState, useRef } from "react";
import {
  LiveSessionsContainer,
  YoutubeContainer,
  YoutubeVideoContainer,
  SessionThumbnail,
} from "./live-sessions-styles";
import { InfoBox } from "../info-box/InfoBox";
import { Separator } from "..";
import { useSessions } from "../../hooks";
import youtubeFill from "@iconify/icons-akar-icons/youtube-fill";

export const LiveSessions = () => {
  const sessions = useSessions();
  const [currentSession, setCurrentSession] = useState(null);
  const [dimensions, setDimensions] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (sessions?.length !== 0) {
      // const id = Math.floor(Math.random() * sessions.length);
      setCurrentSession(sessions[0]);
    }
  }, [sessions]);

  useEffect(() => {
    setDimensions({ height: ref.current.clientHeight, width: ref.current.clientWidth });
    const updateDimensions = () => {
      setDimensions({ height: ref.current.clientHeight, width: ref.current.clientWidth });
    };
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [ref]);

  return (
    <Fragment>
      <LiveSessionsContainer>
        <YoutubeContainer ref={ref}>
          <InfoBox
            // title="Live Sessions"
            title="Latest"
            subtitle={currentSession?.node?.title || ""}
            subtitleUrl={`https://www.youtube.com/watch?v=${currentSession?.node?.videoId}`}
            links={[
              {
                url: `https://www.youtube.com/watch?v=${currentSession?.node?.videoId}`,
                icon: youtubeFill,
              },
            ]}
          />
          <Separator />
          <YoutubeVideoContainer $height={`${dimensions?.height}px` || "100%"}>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube-nocookie.com/embed/${currentSession?.node?.videoId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </YoutubeVideoContainer>
        </YoutubeContainer>
        <Separator vertical />
        <SessionThumbnail
          // src={currentSession?.node?.thumbnail?.url}
          src="assets/galleryone.jpg"
          style={{ height: dimensions?.height || 1 }}
        />
      </LiveSessionsContainer>
    </Fragment>
  );
};
